import React from 'react'
import Grid from '@mui/material/Grid'
import './BuildingAndProperty.scss'
import { IoMdCheckboxOutline } from 'react-icons/io'
import { objectHasAnyValue } from '../../../../../resources/Utils'

const PropertyAccess = React.memo(({ propertyAccessEntity }) => {
  const propertyAccess = React.useMemo(() => propertyAccessEntity || {}, [propertyAccessEntity])

  const accessConcernsHasValues = React.useMemo(() => {
    return objectHasAnyValue(propertyAccess.accessConcerns)
  }, [propertyAccess.accessConcerns])

  return (
    <>
      {propertyAccess &&
      ((propertyAccess.gateDriveway && propertyAccess.gateDriveway.isChecked) ||
        (propertyAccess.knoxBox && propertyAccess.knoxBox.isChecked) ||
        (propertyAccess.gainAccessContact && propertyAccess.gainAccessContact.isChecked) ||
        (propertyAccess.doorsRemotely && propertyAccess.doorsRemotely.isChecked) ||
        (propertyAccess.garageCodeToLiftDoor && propertyAccess.garageCodeToLiftDoor.isChecked) ||
        accessConcernsHasValues) ? (
        <h2 className="section-title">Property Access</h2>
      ) : null}

      {propertyAccess && propertyAccess.gateDriveway && propertyAccess.gateDriveway.isChecked ? (
        <Grid className="section">
          <label className="main-title-label">
            Gate to the driveway:
            {propertyAccess.gateDriveway.isChecked ? (
              <span className="answer">
                {' '}
                Yes
                {propertyAccess.gateDriveway.isChecked && propertyAccess.gateDriveway.code ? (
                  <>{`, ${propertyAccess.gateDriveway.code} `}</>
                ) : null}
              </span>
            ) : (
              ''
            )}
          </label>
        </Grid>
      ) : null}

      {propertyAccess && accessConcernsHasValues ? (
        <Grid className="section">
          <label className="main-title-label">Access concerns:</label>
          <Grid className="container-field">
            {propertyAccess.accessConcerns && propertyAccess.accessConcerns.steepDriveway ? (
              <Grid>
                <label>
                  {<IoMdCheckboxOutline />}
                  {propertyAccess.accessConcerns.steepDriveway ? ' Steep driveway' : ''}{' '}
                </label>
              </Grid>
            ) : null}

            {propertyAccess.accessConcerns && propertyAccess.accessConcerns.narrowDriveway ? (
              <Grid>
                <label>
                  {<IoMdCheckboxOutline />}
                  {propertyAccess.accessConcerns.narrowDriveway ? ' Narrow driveway' : ''}{' '}
                </label>
              </Grid>
            ) : null}

            {propertyAccess.accessConcerns && propertyAccess.accessConcerns.longDriveway ? (
              <Grid>
                <label>
                  {<IoMdCheckboxOutline />}
                  {propertyAccess.accessConcerns.longDriveway ? ' Long driveway' : ''}{' '}
                </label>
              </Grid>
            ) : null}

            {propertyAccess.accessConcerns && propertyAccess.accessConcerns.bridge ? (
              <Grid>
                <label>
                  {<IoMdCheckboxOutline />}
                  {propertyAccess.accessConcerns.bridge ? ' Bridge' : ''}{' '}
                </label>
              </Grid>
            ) : null}

            {propertyAccess.accessConcerns &&
            propertyAccess.accessConcerns.other &&
            propertyAccess.accessConcerns.other.isChecked ? (
              <Grid>
                <label>
                  {propertyAccess.accessConcerns.other ? (
                    <label>
                      {<IoMdCheckboxOutline />}
                      {propertyAccess.accessConcerns.other.isChecked ? (
                        <>
                          {' '}
                          Other
                          {propertyAccess.accessConcerns.other &&
                          propertyAccess.accessConcerns.other.isChecked &&
                          propertyAccess.accessConcerns.other.description &&
                          propertyAccess.accessConcerns.other.description ? (
                            <>{`, ${propertyAccess.accessConcerns.other.description}`}</>
                          ) : null}
                        </>
                      ) : (
                        ''
                      )}
                    </label>
                  ) : (
                    ''
                  )}{' '}
                </label>
              </Grid>
            ) : null}
          </Grid>
        </Grid>
      ) : null}

      {propertyAccess &&
      propertyAccess.gainAccessContact &&
      propertyAccess.gainAccessContact.isChecked &&
      propertyAccess.gainAccessContact.isChecked ? (
        <Grid className="section">
          <label className="main-title-label">
            Does someone else have a key:
            {propertyAccess.gainAccessContact.isChecked ? (
              <span className="answer">
                {' '}
                Yes
                {propertyAccess.gainAccessContact.isChecked &&
                propertyAccess.gainAccessContact.name &&
                propertyAccess.gainAccessContact.name ? (
                  <>{`, ${propertyAccess.gainAccessContact.name}`}</>
                ) : null}
                {propertyAccess.gainAccessContact.isChecked &&
                propertyAccess.gainAccessContact.relationship &&
                propertyAccess.gainAccessContact.relationship ? (
                  <>{`, Relationship: ${propertyAccess.gainAccessContact.relationship}`}</>
                ) : null}
                {propertyAccess.gainAccessContact.isChecked &&
                propertyAccess.gainAccessContact.phone &&
                propertyAccess.gainAccessContact.phone ? (
                  <>
                    , Phone:{' '}
                    <a href={'tel:' + propertyAccess.gainAccessContact.phone}>
                      {propertyAccess.gainAccessContact.phone}
                    </a>
                  </>
                ) : null}
              </span>
            ) : (
              ''
            )}
          </label>

          <Grid>
            {propertyAccess.gainAccessContact.isChecked &&
            propertyAccess.gainAccessContact.address &&
            propertyAccess.gainAccessContact.address ? (
              <Grid>
                <label>Address: {propertyAccess.gainAccessContact.address} </label>
              </Grid>
            ) : null}
          </Grid>
        </Grid>
      ) : null}

      {propertyAccess &&
      propertyAccess.garageCodeToLiftDoor &&
      propertyAccess.garageCodeToLiftDoor.isChecked &&
      propertyAccess.garageCodeToLiftDoor.isChecked ? (
        <Grid className="section">
          <label className="main-title-label">
            Garage code:
            {propertyAccess.garageCodeToLiftDoor.isChecked ? (
              <span className="answer">
                {' '}
                Yes
                {propertyAccess.garageCodeToLiftDoor.isChecked &&
                propertyAccess.garageCodeToLiftDoor.code &&
                propertyAccess.garageCodeToLiftDoor.code ? (
                  <>{`, ${propertyAccess.garageCodeToLiftDoor.code}`}</>
                ) : null}
              </span>
            ) : (
              ''
            )}
          </label>
        </Grid>
      ) : null}

      {propertyAccess &&
      propertyAccess.doorsRemotely &&
      propertyAccess.doorsRemotely.isChecked &&
      propertyAccess.doorsRemotely.isChecked ? (
        <Grid className="section">
          <label className="main-title-label">
            Can someone open the property remotely:
            {propertyAccess.doorsRemotely.isChecked ? (
              <span className="answer">
                {' '}
                Yes
                {propertyAccess.doorsRemotely.isChecked &&
                propertyAccess.doorsRemotely.name &&
                propertyAccess.doorsRemotely.name ? (
                  <>{`, ${propertyAccess.doorsRemotely.name}`}</>
                ) : null}
                {propertyAccess.doorsRemotely.isChecked &&
                propertyAccess.doorsRemotely.phoneNumber &&
                propertyAccess.doorsRemotely.phoneNumber ? (
                  <>
                    , Phone:{' '}
                    <a href={'tel:' + propertyAccess.doorsRemotely.phoneNumber}>
                      {propertyAccess.doorsRemotely.phoneNumber}
                    </a>
                  </>
                ) : null}
              </span>
            ) : (
              ''
            )}
          </label>
        </Grid>
      ) : null}

      {propertyAccess &&
      propertyAccess.knoxBox &&
      propertyAccess.knoxBox.isChecked &&
      propertyAccess.knoxBox.isChecked ? (
        <Grid className="section">
          <label className="main-title-label">
            Knox Box:{' '}
            {propertyAccess.knoxBox.isChecked ? (
              <span className="answer">
                Yes
                {propertyAccess.knoxBox.isChecked &&
                propertyAccess.knoxBox.location &&
                propertyAccess.knoxBox.location ? (
                  <>{`, ${propertyAccess.knoxBox.location.replace ? propertyAccess.knoxBox.location.replace('located', 'location') : null}`}</>
                ) : null}
              </span>
            ) : (
              ''
            )}
          </label>
        </Grid>
      ) : null}
    </>
  )
})

export default PropertyAccess
